import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Paper, Grid, Divider, ClickAwayListener, ListItemButton, ListItemText, IconButton, Typography, Fade } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Entry from './Entry';

const TIPS = {
    init: 'click in the textbox to add an entry',
    edit: 'adjust attributes or click away to complete editing',
    exist: 'click to edit an existing entry'
};

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        top: '45%',
        left: '50%',
        width: '80vw !important',
        transform: 'translate(-50%, -50%)',
    },
    paper: {
        padding: theme.spacing(1),
        border: '1px solid #EEE',
    },
    text: {
        '& span': { lineHeight: 1 },
    },
    prompt: {
        height: '40px !important',
        borderRight: '1px solid #AAA !important',
    },
}));

const Search = () => {
    const classes = useStyles();

    const [edit, setEdit] = useState(-1);
    const [current, setCurrent] = useState({});
    const [all, setAll] = useState([]);
    const [tip, setTip] = useState('init');

    const handleClickAway = () => {
        const updatedAll = [...all];
        updatedAll[edit] = current;
        setAll(updatedAll);
        setEdit(-1);
    };
    const handleSelect = (i) => (e) => {
        e.stopPropagation()
        if (i === edit) {
            return;
        }
        setCurrent(all[i]);
        setEdit(i);
        setTip('edit');
    };
    const handleAdd = (e) => {
        e.stopPropagation()
        if (edit !== -1) {
            handleClickAway();
            return;
        }
        setAll([...all, undefined]);
        setEdit(all.length);
        setTip('edit');
    };
    const handleDelete = (i) => () => {
        const updatedAll = [...all];
        updatedAll.splice(i, 1);
        setAll(updatedAll);
        setEdit(-1);
        setTip('init')
    };
    const handleClearAll = (e) => {
        e.stopPropagation()
        setAll([]);
        setEdit(-1);
        setTip('init');
    };

    const box = (
        <Grid container alignItems="center" wrap="nowrap" spacing={1} onClick={handleAdd}>
            {all.map((entry, i) => (
                <Grid item key={`entry-list-item-${i}`} onMouseOut={() => setTip('init')}>
                    {i === edit ? (
                        <Entry show={i === edit} current={entry} setCurrent={setCurrent} onDelete={handleDelete(i)} onHover={() => setTip('edit')} />
                    ) : !!entry && (
                        <Fade orientation="horizontal" in={true}>
                            <ListItemButton className="btn" onClick={handleSelect(i)} onMouseOver={() => setTip('exist')}>
                                <ListItemText
                                    primary={<Typography variant="overline" color="primary"><strong>{entry.category}</strong></Typography>}
                                    secondary={(
                                        <Typography variant="caption" color="secondary" component='p'>
                                            {`${entry.key ? `${entry.key} ` : ''}${entry.operator ? '=' : '!='} ${entry.value}`}
                                        </Typography>
                                    )}
                                    className={classes.text}
                                />
                            </ListItemButton>
                        </Fade>
                    )}
                </Grid>
            ))}
            <Grid item><Divider orientation="vertical" flexItem className={`${classes.prompt} blink`} /></Grid>
            <Grid item style={{ flex: 1 }} />
            {all.length > 0 && <Grid item><IconButton color="secondary" onClick={handleClearAll}><CloseIcon /></IconButton></Grid>}
        </Grid>
    );

    return (
        <Grid container direction="column" spacing={4} className={classes.root}>
            <Grid item>
                <Typography variant="h4">Live Demo:</Typography>
            </Grid>
            <Grid item>
                <ClickAwayListener onClickAway={handleClickAway}>
                    <Paper elevation={4} className={classes.paper}>{box}</Paper>
                </ClickAwayListener>
            </Grid>
            <Grid item style={{ marginTop: 50 }}>
                <Typography variant="h5" gutterBottom>Tip:</Typography>
                <Typography variant="h5">{TIPS[tip]}</Typography>
            </Grid>
        </Grid>
    );
};

export default Search;
